module.exports = __webpack_public_path__ + "img/tips-night-icon.62691592.svg";